var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8332 2.8335H8.49984C7.74839 2.8335 7.02772 3.13201 6.49637 3.66336C5.96501 4.19471 5.6665 4.91538 5.6665 5.66683V28.3335C5.6665 29.0849 5.96501 29.8056 6.49637 30.337C7.02772 30.8683 7.74839 31.1668 8.49984 31.1668H25.4998C26.2513 31.1668 26.972 30.8683 27.5033 30.337C28.0347 29.8056 28.3332 29.0849 28.3332 28.3335V11.3335L19.8332 2.8335Z",
    stroke: "#3d3d5c",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 2.8335V11.3335H28.3335",
    stroke: "#3d3d5c",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6668 18.4165H11.3335",
    stroke: "#3d3d5c",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6668 24.0835H11.3335",
    stroke: "#3d3d5c",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 12.75H12.7502H11.3335",
    stroke: "#3d3d5c",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.7a0689a67c794ef3327316718e404832.svg";
export { ForwardRef as ReactComponent };